export const currencyMap: Record<
	string,
	{ symbol: string; position: "prefix" | "suffix" }
> = {
	SEK: { symbol: "kr", position: "suffix" },
	USD: { symbol: "$", position: "prefix" },
	GBP: { symbol: "£", position: "prefix" }
};
